module.exports = __webpack_public_path__ + "static/media/icon-send-with-border.41bc43b8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/icon-send-with-border.svg
// module id = 1228
// module chunks = 19